module.exports = __webpack_public_path__ + "static/media/yale-smart-safe-feature.8895a69b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/yale-smart-safe-feature.jpg
// module id = 1298
// module chunks = 0